import { get, put } from '../..';
import { buildUrl } from '../../../utils';

export const getWebpunchLink = (foreignId: string) =>
  get(
    buildUrl(
      `/v1/qwfmbackoffice/clientIntegrations/getWebPunchLink/${foreignId}`,
    ),
  );

export const webPunchLinkConfigure = (
  unitId: string,
  integrationKeyId: string,
) =>
  put(buildUrl('/v1/qwfmbackoffice/clientIntegrations/webPunchLinkConfigure'), {
    unitId,
    integrationKeyId,
  });
